module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_機能満足度No.1-4850cf2ad2e7f3c85b2e26e4c7a6b8bd.png";